import { render } from "./ParticleVue3.vue?vue&type=template&id=2e5d64ba&scoped=true"
import script from "./ParticleVue3.vue?vue&type=script&lang=js"
export * from "./ParticleVue3.vue?vue&type=script&lang=js"

import "./ParticleVue3.vue?vue&type=style&index=0&id=2e5d64ba&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5d64ba"]])

export default __exports__